import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { AtiraTabs } from '../../components/AtiraTabs';
import { Button } from '../../components/Button';
import { Flex } from '../../components/Flex';
import { UserHeader } from '../../components/UserHeader';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageMeta } from '../../model/meta/PageMeta';
import { QRActions } from '../../redux/QR/qr.slice';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { userSliceSelectors } from '../../redux/user/user.selector';
import { Breakpoints } from '../../theme/Breakpoints';
import { Rounded } from '../../theme/Rounded';
import { Shadow } from '../../theme/Shadow';
import { Spacing } from '../../theme/Spacing';
import { UserQRs } from './UserQRs';
import { QRGeneratorModal } from './components/QRGeneratorModal';

const HeaderWrapper = styled(Flex)`
  display: none;
  margin-top: ${Spacing.s};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    display: flex;
  }
`;

const StyledButton = styled(Button)`
  position: fixed;
  bottom: ${Spacing.xl};
  inset-inline-end: ${Spacing.xl};
  width: 3.5rem;
  aspect-ratio: 1 / 1;
  border-radius: ${Rounded.circle};
  box-shadow: ${Shadow.MD};

  &:hover {
    background-color: ${({ theme }) => theme.lightMain};
  }
`;

export const QRRoute: React.FC = () => {
  const [qrGeneratorModalOpen, setQrGeneratorModalOpen] = useState(false);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  useDocumentTitle(`${t('app.name').toUpperCase()} - ${t('common.my_qrs')}`);

  const loggedInUserId = useAppSelector(
    userSliceSelectors.selectLoggedInUserId,
  )!;

  useEffect(() => {
    dispatch(
      QRActions.getUserQRs({ userId: loggedInUserId, meta: PageMeta.create() }),
    );
  }, [dispatch, loggedInUserId]);

  useEffect(() => {
    const isNavigatedToCreate = location.state?.isNavigatedToCreate;

    if (isNavigatedToCreate) {
      setQrGeneratorModalOpen(true);
      navigate(location, { replace: true });
    }
  }, [location, navigate]);

  return (
    <Fragment>
      <AtiraTabs
        items={[
          {
            key: 'qrs',
            label: t('side_menu.my_qrs'),
            children: <UserQRs />,
          },
        ]}
        sideComponent={
          <HeaderWrapper>
            <UserHeader />
          </HeaderWrapper>
        }
      />
      <QRGeneratorModal
        open={qrGeneratorModalOpen}
        setOpen={setQrGeneratorModalOpen}
      />

      <StyledButton
        icon={faPlus}
        onClick={() => setQrGeneratorModalOpen(true)}
      />
    </Fragment>
  );
};
